import { difference } from 'lodash-es';

export enum WhatsAppTemplateNames {
  NewInvite = 'new_invite',
  PraxiaNewInvite = 'invite_praxia_new',
  RightTimeMatchingPositionFound = 'chance_zur_richtigen_zeit_passende_position_gefunden_details',
  ThanksCallUploadDocumentsOrEmail = 'danke_telefonat_bewerbungsunterlagen_hochladen_oder_per_mail',
  ThanksCallSendDocuments = 'danke_telefonat_bewerbungsunterlagen_zuschicken_melde_mich',
  ThanksCallWillReachOutSoon = 'danke_fuers_telefonat_melde_mich_zeitnah_mit',
  // eslint-disable-next-line eslint-compat/naming-convention
  CanISupportYouOrPauseSearch = 'kann_ich_dich_unterstuetzen_sonst_suche_pausieren_bis_du_dich',
  HiContactPersonThreeFacilitiesFound = 'hi_ich_bin_deine_ansprechperson_von_pflegia_3_einrichtungen_gefunden_hast_du_zeit_zu_telefon',
  FollowUp24hFeedback = 'danke_fuer_deine_rueckmeldung_wann_erreiche_ich_dich_telefonisch',
  FollowUpDay2Feedback = 'hallo_koenntest_du_mir_noch_eine_kurze_rueckmeldung_geben_wann_erreiche_ich_dich',
  MatchObDuShort = 'wvl_match_ob_du_short',
  VtanTvsDu = 'vtan_tvs_du',
  VtanDu = 'vtan_du',
}

/**
 * The templates announcing a new job offer. Which of them applies depends on the candidate's source domain.
 */
export const WHATSAPP_INVITE_TEMPLATE_NAMES: WhatsAppTemplateNames[] = [
  WhatsAppTemplateNames.NewInvite,
  WhatsAppTemplateNames.PraxiaNewInvite,
];

export const WHATSAPP_BUSINESS_CHAT_TEMPLATE_NAMES = [
  WhatsAppTemplateNames.RightTimeMatchingPositionFound,
  WhatsAppTemplateNames.ThanksCallUploadDocumentsOrEmail,
  WhatsAppTemplateNames.ThanksCallSendDocuments,
  WhatsAppTemplateNames.ThanksCallWillReachOutSoon,
  WhatsAppTemplateNames.CanISupportYouOrPauseSearch,
  WhatsAppTemplateNames.HiContactPersonThreeFacilitiesFound,
  WhatsAppTemplateNames.FollowUp24hFeedback,
  WhatsAppTemplateNames.FollowUpDay2Feedback,
  WhatsAppTemplateNames.MatchObDuShort,
  WhatsAppTemplateNames.VtanTvsDu,
  WhatsAppTemplateNames.VtanDu,
];

const WHATSAPP_BUSINESS_CHAT_CANDIDATE_WITH_MATCH_TEMPLATE_NAMES: WhatsAppTemplateNames[] = [
  WhatsAppTemplateNames.RightTimeMatchingPositionFound,
  WhatsAppTemplateNames.MatchObDuShort,
  WhatsAppTemplateNames.VtanTvsDu,
  WhatsAppTemplateNames.VtanDu,
];

export const WHATSAPP_BUSINESS_CHAT_CANDIDATE_WITHOUT_MATCH_TEMPLATE_NAMES: WhatsAppTemplateNames[] = difference(
  WHATSAPP_BUSINESS_CHAT_TEMPLATE_NAMES,
  WHATSAPP_BUSINESS_CHAT_CANDIDATE_WITH_MATCH_TEMPLATE_NAMES,
);

export const WHATSAPP_TEMPLATE_NAMES_I18N = {
  [WhatsAppTemplateNames.NewInvite]: 'Neue Einladung',
  [WhatsAppTemplateNames.PraxiaNewInvite]: 'Neue Praxia Einladung',
  [WhatsAppTemplateNames.RightTimeMatchingPositionFound]: 'Chance: Passende Position gefunden',
  [WhatsAppTemplateNames.ThanksCallUploadDocumentsOrEmail]: 'Danke Telefonat: Unterlagen hochladen oder per E-Mail',
  [WhatsAppTemplateNames.ThanksCallSendDocuments]: 'Danke Telefonat: Unterlagen zuschicken',
  [WhatsAppTemplateNames.ThanksCallWillReachOutSoon]: 'Danke Telefonat: Melde mich mit Updates',
  [WhatsAppTemplateNames.CanISupportYouOrPauseSearch]: 'Kann ich dich unterstützen / Suche pausieren',
  [WhatsAppTemplateNames.HiContactPersonThreeFacilitiesFound]: 'Hi Ansprechperson: 3 Einrichtungen gefunden',
  [WhatsAppTemplateNames.FollowUp24hFeedback]: '24h RM',
  [WhatsAppTemplateNames.FollowUpDay2Feedback]: 'Tag 2',
  [WhatsAppTemplateNames.MatchObDuShort]: 'Match: Kurzvorstellung',
  [WhatsAppTemplateNames.VtanTvsDu]: 'Terminvorschlag: zwei Werktage',
  [WhatsAppTemplateNames.VtanDu]: 'Terminvorschläge senden',
};
